<div class="language-switcher">
  <select id="language" (change)="switchLanguage($event)">
    <option *ngFor="let lang of languages" [value]="lang.code">
      {{ lang.name }}
    </option>
  </select>
</div>